<div class="generic-dialog" siAccessibilityDialog>
  <p-dialog [(visible)]="displayDialog"
            (visibleChange)="onVisibleChange($event)"
            [modal]="true"
            [dismissableMask]="true"
            appendTo="body"
            styleClass="{{dialogSizeClass}} {{dialogStyleClass}}"
            [draggable]="draggable"
            [closable]="closable">
    <div [ngClass]="isScrollable ? 'generic-dialog_scroll si-scroll-thin': ''">
      <div>
        <div *ngIf="dialogTitle" class="generic-dialog_title mb-2 {{dialogTitleStyleClass}}" [innerHTML]="dialogTitle | translate"></div>
        <div *ngIf="dialogImg" class="text-center mb-3">
          <img src="{{dialogImg}}" width="250">
        </div>
        <div *ngIf="dialogText" class="generic-dialog_text" [innerHTML]="dialogText | translate"></div>
        <ng-content></ng-content>
      </div>
      <div *ngIf="button1Text || button2Text || button3Text"
           class="row pasi-gap-v-10 mt-4"
           [ngClass]="centerButtons ? 'justify-content-center' : 'justify-content-end'">
        <div *ngIf="button1Text" class="col-12 col-sm-6 col-lg-auto">
          <ng-container *ngIf="button1Href; else button1">
            <si-go-to-route-button text="{{button1Text}}"
                                   [href]="[button1Href]"
                                   [params]="button1Params"
                                   styleClass="{{button1Class}} w-100"
            ></si-go-to-route-button>
          </ng-container>
          <ng-template #button1>
            <button class="{{button1Class}} w-100"
                    translate="{{button1Text}}"
                    type="button"
                    (click)="onClickButton1()"
                    [disabled]="button1Disabled"
            ></button>
          </ng-template>
        </div>
        <div *ngIf="button2Text" class="col-12 col-sm-6 col-lg-auto">
          <ng-container *ngIf="button2Href; else button2">
            <si-go-to-route-button text="{{button2Text}}"
                                   [href]="[button2Href]"
                                   [params]="button2Params"
                                   styleClass="{{button2Class}} w-100"
            ></si-go-to-route-button>
          </ng-container>
          <ng-template #button2>
            <button class="{{button2Class}} w-100"
                    translate="{{button2Text}}"
                    type="button"
                    (click)="onClickButton2()"
                    [disabled]="button2Disabled"
            ></button>
          </ng-template>
        </div>
        <div *ngIf="button3Text" class="col-12 col-sm-6 col-lg-auto">
          <ng-container *ngIf="button3Href; else button3">
            <si-go-to-route-button text="{{button3Text}}"
                                   [href]="[button3Href]"
                                   [params]="button3Params"
                                   styleClass="{{button3Class}} w-100"
            ></si-go-to-route-button>
          </ng-container>
          <ng-template #button3>
            <button class="{{button3Class}} w-100"
                    translate="{{button3Text}}"
                    type="button"
                    (click)="onClickButton3()"
                    [disabled]="button3Disabled"
            ></button>
          </ng-template>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
